var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('i',{staticClass:"vehicle-icon custom-icon v-icon",class:_vm.customClasses,style:(_vm.styles)},[_c(_vm.image,{tag:"component",attrs:{"width":_vm.getSize(),"height":_vm.getSize(),"fill":"currentColor"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }